import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import SomaJourney from "../components/SomaJourney";
import { API } from "../lib/api";

export default function CafeJourneyPage() {
  const { slug } = useParams();
  const [cafe, setCafe] = useState(null);
  const [status, setStatus] = useState("loading"); // loading | ok | notfound

  useEffect(() => {
    let cancelled = false;
    axios.get(`${API}/cafes/by-slug/${slug}`)
      .then(({ data }) => { if (!cancelled) { setCafe(data); setStatus("ok"); } })
      .catch(() => { if (!cancelled) setStatus("notfound"); });
    return () => { cancelled = true; };
  }, [slug]);

  if (status === "loading") {
    return (
      <div className="page" data-testid="cafe-loading" style={{ minHeight: "100vh", display: "flex", alignItems: "center", justifyContent: "center" }}>
        <p className="italic-quote" style={{ color: "var(--gold)", fontSize: 18 }}>steeping…</p>
      </div>
    );
  }

  if (status === "notfound") {
    return (
      <div className="page" data-testid="cafe-notfound" style={{ minHeight: "100vh", padding: 40, textAlign: "center" }}>
        <div className="grain" /><div className="vignette" />
        <p className="eyebrow" style={{ marginTop: 120 }}>not found</p>
        <h2 className="italic-quote" style={{ fontSize: 28, marginTop: 24, color: "var(--cream)" }}>
          We couldn't find a cafe at /c/{slug}.
        </h2>
        <p className="body-copy" style={{ marginTop: 20 }}>
          Double-check the link, or just start the journey directly.
        </p>
        <a href="/" className="primary-btn" data-testid="back-to-soma" style={{ marginTop: 28, display: "inline-block", textDecoration: "none", padding: "14px 28px", width: "auto" }}>
          Open Soma Lixir
        </a>
      </div>
    );
  }

  return <SomaJourney cafe={cafe} />;
}
